import React from "react";

export default function Definitions(props) {
  //console.log(props.definitions);
  if (props.definitions.text) {
    return (
      <section className="Meanings">
        <h3 className="part-of-speech">
          {props.definitions.word}(<em>{props.definitions.partOfSpeech}</em>)
        </h3>
        <p>{props.definitions.text}</p>
      </section>
    );
  } else {
    return null;
  }
}
